import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';
import { GameResultType } from '~/core/enums';
import { GameResult } from '~/views/pages/gameCenter/types';

import {
    Result,
    GameResultContainer,
    GameResultsContainer,
    Record,
    TeamContainer,
    TeamInformation,
    NoGamesMessage,
} from './styles';

type Props = {
    teamName: string;
    teamRecord: string;
    results?: Array<GameResult>;
};

const TeamRecord: FC<Props> = ({ teamName, teamRecord, results }) => {
    return (
        <TeamContainer>
            <TeamInformation>
                <div role="heading" aria-level={3}>
                    {teamName}
                </div>
                <Record>{teamRecord}</Record>
            </TeamInformation>
            <GameResultsContainer $hasRecord={results && results.length > 0}>
                {results && results?.length > 0 ? (
                    results.map((result, index) => (
                        <GameResultContainer key={index}>
                            <Result
                                $isWin={
                                    result.gameResult === GameResultType.win ||
                                    result.gameResult === GameResultType.soWin ||
                                    result.gameResult === GameResultType.otWin
                                }
                            >
                                {result.opponentAbbrev}
                            </Result>
                            <CoreUtils.SafeFormattedMessage
                                message={CommonMessages.gameResultDescriptions.abbreviations[result.gameResult]}
                            />
                        </GameResultContainer>
                    ))
                ) : (
                    <NoGamesMessage>
                        <FormattedMessage
                            description="A phrase describing that no games have been played yet"
                            defaultMessage="No games played"
                        />
                    </NoGamesMessage>
                )}
            </GameResultsContainer>
        </TeamContainer>
    );
};

export default TeamRecord;
